import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useInfo } from "@/context/InfoContext";
import { Logo } from "@/components/site/Header";
import { socialLinks } from "@/components/site/social";
import { ADDRESS, MAPS_URL, waLink } from "@/lib/api";
import { usePwaInstall } from "@/hooks/usePwaInstall";

export const WhatsAppFab = () => {
  const { info } = useInfo();
  const url = waLink(info?.settings?.whatsapp);
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-[#111111] text-white flex items-center justify-center shadow-lg hover:scale-105 transition-transform duration-200"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
};

export const Footer = () => {
  const { info } = useInfo();
  const s = info?.settings;
  const socials = socialLinks(s);
  const { canInstall, install } = usePwaInstall();
  return (
    <footer className="bg-[#111111] text-zinc-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5 space-y-4">
          <div className="[&_span]:!text-white [&>a>span:first-child]:!bg-white [&>a>span:first-child]:!text-[#111111]">
            <Logo testid="footer-logo" />
          </div>
          <p className="text-sm text-zinc-400 max-w-xs">Estilo, precisión y elegancia en cada corte.</p>
          {canInstall && (
            <button onClick={install} data-testid="pwa-install-button" className="text-xs tracking-[0.2em] uppercase border border-zinc-600 px-4 py-2 hover:bg-white hover:text-[#111111] transition-colors">
              Instalar app
            </button>
          )}
        </div>
        <div className="md:col-span-3 space-y-3 text-sm">
          <p className="text-xs tracking-[0.25em] uppercase text-zinc-500">Visítanos</p>
          <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="block hover:text-white" data-testid="footer-address">{ADDRESS}</a>
          {s?.phone && <a href={`tel:${s.phone}`} className="block hover:text-white" data-testid="footer-phone">{s.phone}</a>}
          {s?.contact_email && <a href={`mailto:${s.contact_email}`} className="block hover:text-white" data-testid="footer-email">{s.contact_email}</a>}
        </div>
        <div className="md:col-span-2 space-y-3 text-sm">
          <p className="text-xs tracking-[0.25em] uppercase text-zinc-500">Enlaces</p>
          <Link to="/reservar" className="block hover:text-white" data-testid="footer-link-book">Reservar cita</Link>
          <Link to="/mi-cuenta" className="block hover:text-white" data-testid="footer-link-account">Mi cuenta</Link>
          <Link to="/gestionar-reserva" className="block hover:text-white" data-testid="footer-link-manage">Gestionar reserva</Link>
        </div>
        <div className="md:col-span-2 space-y-3 text-sm">
          {socials.length > 0 && <p className="text-xs tracking-[0.25em] uppercase text-zinc-500">Síguenos</p>}
          {socials.map(({ key, label, url }) => (
            <a key={key} href={url} target="_blank" rel="noopener noreferrer" className="block hover:text-white" data-testid={`footer-social-${key}`}>{label}</a>
          ))}
        </div>
      </div>
      <div className="border-t border-zinc-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-zinc-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} P7 BARBING SALON. Todos los derechos reservados.</span>
          <span>Donostia / San Sebastián</span>
        </div>
      </div>
    </footer>
  );
};
